import Description from "../../components/common/Description";
import { tokenGenerateInfo } from "../../components/common/json-data/TokenGenerateData";
import Grid from "@mui/material/Grid";
import ApiTest from "../../components/common/ApiTest";
import React from "react";
import { generateToken } from "../../components/common/constants";
import MiniDrawer from "../../components/navBar/Sidenav";
import { Box } from "@mui/system";
import { styled, useTheme } from "@mui/material/styles";
function GenerateToken() {
  return (
    <div style={{ display: "flex" }}>
      <MiniDrawer />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Description bodyDesc={tokenGenerateInfo[0]} />
          </Grid>
          <Grid item xs={6}>
            <ApiTest apidata={generateToken} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default GenerateToken;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
